import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { IDHospitalApi, AddDiagnosisRqData, IDDiagnosisApi } from 'models/DCK/DCKApiTypes';
import { CounselDateTimeRqData, VoucherAddDiagnosisRqData } from 'models/MindUp/MindUpTypes';

class AddDiagnosisApi {
    async hospitalFindById(url: string, token: string): Promise<IDHospitalApi> {
        try {
            const response = await axios.get(apiPaths.hospitalFindById + url, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async addDiagnosis(rqData: AddDiagnosisRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.post(apiPaths.addDiagnosis, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async governmentAddDiagnosis(rqData: VoucherAddDiagnosisRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.post(apiPaths.addDiagnosis, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateCounselDateTime(rqData: CounselDateTimeRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.updateCounselDateTime, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const addDiagnosisApi = new AddDiagnosisApi();
